"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _components = require("../../../components");

var _code = _interopRequireDefault(require("../../../assets/img/code.svg"));

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      height: '100%',
      backgroundColor: function backgroundColor(_ref) {
        var selected = _ref.selected;
        return selected ? theme.palette.grey[200] : theme.palette.background.paper;
      }
    },
    filled: _defineProperty({
      width: '100%',
      height: '100%'
    }, theme.breakpoints.up('md'), {
      padding: theme.spacing(3)
    }),
    divider: {
      width: '20%',
      height: 4,
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 8,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    tooltipContainer: {
      position: 'absolute',
      top: 0,
      right: 0
    },
    relativeTooltip: {
      position: 'relative'
    },
    icon: {
      height: 40,
      width: 40
    },
    title: {
      color: theme.palette.primary.main
    }
  };
});

var SelectCard = function SelectCard(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      tooltip = _ref2.tooltip,
      imgSrc = _ref2.imgSrc,
      icon = _ref2.icon,
      selected = _ref2.selected,
      _ref2$onSelect = _ref2.onSelect,
      onSelect = _ref2$onSelect === void 0 ? function () {} : _ref2$onSelect,
      props = _objectWithoutProperties(_ref2, ["className", "title", "tooltip", "imgSrc", "icon", "selected", "onSelect"]);

  var classes = useStyles({
    selected: selected
  });

  var handleTooltipDown = function handleTooltipDown(e) {
    e.stopPropagation();
  };

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.ButtonBase, {
    className: classes.filled,
    onClick: onSelect
  }, tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tooltipContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.relativeTooltip
  }, /*#__PURE__*/_react.default.createElement(_components.Flex, {
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: tooltip
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onMouseDown: handleTooltipDown,
    component: "span"
  }, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null)))))), /*#__PURE__*/_react.default.createElement(_components.Flex, {
    dir: "ttb",
    className: classes.filled,
    justify: "center",
    alignItems: "center"
  }, icon && /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
    component: icon,
    className: classes.icon
  }), !icon && /*#__PURE__*/_react.default.createElement("img", {
    src: imgSrc || _code.default,
    alt: "placeholder",
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    dangerouslySetInnerHTML: {
      __html: title
    },
    className: classes.title
  }))));
};

exports.SelectCard = SelectCard;
SelectCard.propTypes = {
  title: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  imgSrc: _propTypes.default.string,
  onSelect: _propTypes.default.func,
  selected: _propTypes.default.bool,
  icon: _propTypes.default.object
};
var _default = SelectCard;
exports.default = _default;